import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";
import PageHeader from "../../components/ui/PageHeader";
import MediaLibrary from "../../components/ui/MediaLibrary";
import HelpVideos from "./HelpVideos";

/** Medier (superadmin): billederne og videoerne, Breefer selv bruger - og hjælpevideoerne i kundeportalen. */
export default function Media() {
  const [t] = useTranslation("global");
  const [tab, setTab] = useState<"media" | "help">("media");
  return (
    <Layout>
      <PageHeader title={t("media.title")} description={t("media.intro")} />
      <Box sx={{ width: "100%" }}>
        <Tabs value={tab} onChange={(_event, next) => setTab(next)} sx={{ mb: 2, "& .MuiTab-root": { textTransform: "none" } }}>
          <Tab value="media" label={t("media.tabMedia")} />
          <Tab value="help" label={t("media.tabHelp")} />
        </Tabs>
        {tab === "media" ? <MediaLibrary manage /> : <HelpVideos />}
      </Box>
    </Layout>
  );
}
